import React, { useState, useEffect } from 'react';
import syncService from '../services/syncService';

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    zIndex: 3000
  },
  modal: {
    backgroundColor: 'white',
    borderRadius: '20px 20px 0 0',
    width: '100%',
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 -10px 40px rgba(0, 0, 0, 0.3)'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px',
    borderBottom: '2px solid #fef3c7',
    background: 'linear-gradient(135deg, #fffbeb, #fef3c7)'
  },
  title: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#92400e',
    margin: 0
  },
  subtitle: {
    fontSize: '12px',
    color: '#b45309',
    marginTop: '4px'
  },
  closeButton: {
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    border: 'none',
    backgroundColor: 'white',
    fontSize: '20px',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
  },
  content: {
    flex: 1,
    overflow: 'auto',
    padding: '20px'
  },
  formGroup: {
    marginBottom: '16px'
  },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '600',
    color: '#475569',
    marginBottom: '6px'
  },
  required: {
    color: '#ef4444'
  },
  select: {
    width: '100%',
    padding: '12px',
    fontSize: '15px',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    outline: 'none',
    boxSizing: 'border-box',
    backgroundColor: 'white'
  },
  input: {
    width: '100%',
    padding: '12px',
    fontSize: '15px',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    outline: 'none',
    boxSizing: 'border-box'
  },
  textarea: {
    width: '100%',
    padding: '12px',
    fontSize: '15px',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    outline: 'none',
    resize: 'vertical',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    minHeight: '120px'
  },
  templateInfo: {
    padding: '10px 12px',
    background: '#f0fdf4',
    borderRadius: '8px',
    fontSize: '12px',
    color: '#166534',
    marginBottom: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  photoSection: {
    marginTop: '16px'
  },
  photoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '8px',
    marginTop: '8px'
  },
  photoSlot: {
    aspectRatio: '1',
    border: '2px dashed #d1d5db',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    background: '#f9fafb',
    fontSize: '24px',
    overflow: 'hidden',
    position: 'relative'
  },
  photoImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  deletePhotoBtn: {
    position: 'absolute',
    top: '4px',
    right: '4px',
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    background: '#ef4444',
    color: 'white',
    border: 'none',
    fontSize: '14px',
    cursor: 'pointer'
  },
  footer: {
    display: 'flex',
    gap: '12px',
    padding: '20px',
    borderTop: '2px solid #f1f5f9'
  },
  cancelButton: {
    flex: 1,
    padding: '14px',
    fontSize: '16px',
    fontWeight: '600',
    backgroundColor: 'white',
    color: '#64748b',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    cursor: 'pointer'
  },
  saveButton: {
    flex: 1,
    padding: '14px',
    fontSize: '16px',
    fontWeight: '600',
    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(245, 158, 11, 0.3)'
  },
  loadingTemplates: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 12px',
    background: '#fef3c7',
    borderRadius: '8px',
    fontSize: '13px',
    color: '#92400e',
    marginBottom: '12px'
  }
};

export default function ObservationLevageModalMobile({ isOpen, onClose, onSave, point, codeAnnexe }) {
  const [templates, setTemplates] = useState([]);
  const [loadingTemplates, setLoadingTemplates] = useState(true);
  const [selectedTemplateId, setSelectedTemplateId] = useState('');
  const [formData, setFormData] = useState({
    constat: '',
    reference_reglementaire: 'Arrêté du 1er mars 2004',
    photos: []
  });
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (isOpen && point) {
      loadTemplates();
    }
  }, [isOpen, point, codeAnnexe]);

  const loadTemplates = async () => {
    setLoadingTemplates(true);
    try {
      const localTemplates = await syncService.getLocalTemplatesLevage(codeAnnexe, point.numero);
      setTemplates(localTemplates);
      console.log(`📚 ${localTemplates.length} templates trouvés pour ${codeAnnexe} - ${point.numero}`);
    } catch (error) {
      console.error('❌ Erreur chargement templates:', error);
    } finally {
      setLoadingTemplates(false);
    }
  };

  if (!isOpen) return null;

  const handleTemplateChange = (templateId) => {
    setSelectedTemplateId(templateId);
    
    if (templateId && templateId !== 'manual') {
      const template = templates.find(t => t.id === templateId);
      if (template) {
        setFormData(prev => ({
          ...prev,
          constat: template.constat || '',
          reference_reglementaire: template.reference_reglementaire || 'Arrêté du 1er mars 2004'
        }));
      }
    }
  };

  const handlePhotoCapture = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.capture = 'environment';
    
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      setUploading(true);
      const reader = new FileReader();
      reader.onload = (event) => {
        setFormData(prev => ({
          ...prev,
          photos: [...prev.photos, event.target.result]
        }));
        setUploading(false);
      };
      reader.readAsDataURL(file);
    };

    input.click();
  };

  const handleRemovePhoto = (index) => {
    setFormData(prev => ({
      ...prev,
      photos: prev.photos.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = () => {
    if (!formData.constat.trim()) {
      alert('Veuillez saisir un constat');
      return;
    }

    const observation = {
      localisation: point.libelle,
      element: `Point ${point.numero}`,
      constat: formData.constat,
      reference_reglementaire: formData.reference_reglementaire,
      photos: formData.photos,
      custom: !selectedTemplateId || selectedTemplateId === 'manual',
      template_id: selectedTemplateId && selectedTemplateId !== 'manual' ? selectedTemplateId : null,
      element_ref: {
        type: 'point_controle',
        point_numero: point.numero,
        point_libelle: point.libelle,
        section_titre: point.sectionTitre || ''
      }
    };

    onSave(observation);
    
    // Reset form
    setSelectedTemplateId('');
    setFormData({
      constat: '',
      reference_reglementaire: 'Arrêté du 1er mars 2004',
      photos: []
    });
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div style={styles.header}>
          <div>
            <h3 style={styles.title}>🔺 Observation - Point {point.numero}</h3>
            <p style={styles.subtitle}>{point.libelle}</p>
          </div>
          <button onClick={onClose} style={styles.closeButton}>✕</button>
        </div>

        {/* Content */}
        <div style={styles.content}>
          {/* Sélection template */}
          <div style={styles.formGroup}>
            <label style={styles.label}>📚 Template d'observation</label>
            
            {loadingTemplates ? (
              <div style={styles.loadingTemplates}>
                <span>⏳</span>
                Chargement des templates...
              </div>
            ) : (
              <>
                <select 
                  value={selectedTemplateId} 
                  onChange={(e) => handleTemplateChange(e.target.value)}
                  style={{...styles.select, whiteSpace: 'normal'}}
                >
                  <option value="">-- Sélectionnez un template ou saisissez manuellement --</option>
                  <option value="manual">✏️ Saisie manuelle</option>
                  {templates.map(template => (
                    <option key={template.id} value={template.id}>
                      {template.constat?.substring(0, 100) || template.titre}{template.constat?.length > 100 ? '...' : ''}
                    </option>
                  ))}
                </select>
                
                {templates.length === 0 && (
                  <div style={{ ...styles.templateInfo, background: '#fef3c7', color: '#92400e' }}>
                    <span>ℹ️</span>
                    Aucun template pour ce point. Synchronisez les templates depuis le menu.
                  </div>
                )}
                
                {selectedTemplateId && selectedTemplateId !== 'manual' && (
                  <div style={styles.templateInfo}>
                    <span>✓</span>
                    Template sélectionné - Vous pouvez modifier le texte ci-dessous
                  </div>
                )}
              </>
            )}
          </div>

          {/* Constat */}
          <div style={styles.formGroup}>
            <label style={styles.label}>
              Constat / Préconisation <span style={styles.required}>*</span>
            </label>
            <textarea
              value={formData.constat}
              onChange={(e) => setFormData({ ...formData, constat: e.target.value })}
              style={styles.textarea}
              placeholder="Décrivez la non-conformité constatée et les préconisations..."
            />
          </div>

          {/* Référence réglementaire */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Référence réglementaire</label>
            <input
              type="text"
              value={formData.reference_reglementaire}
              onChange={(e) => setFormData({ ...formData, reference_reglementaire: e.target.value })}
              style={styles.input}
              placeholder="Ex: Arrêté du 1er mars 2004"
            />
          </div>

          {/* Photos */}
          <div style={styles.photoSection}>
            <label style={styles.label}>📷 Photos ({formData.photos.length})</label>
            <div style={styles.photoGrid}>
              {formData.photos.map((photo, index) => (
                <div key={index} style={{ ...styles.photoSlot, border: '2px solid #f59e0b' }}>
                  <img src={photo} style={styles.photoImage} alt={`Photo ${index + 1}`} />
                  <button
                    style={styles.deletePhotoBtn}
                    onClick={() => handleRemovePhoto(index)}
                  >
                    ✕
                  </button>
                </div>
              ))}
              {formData.photos.length < 3 && (
                <div style={styles.photoSlot} onClick={handlePhotoCapture}>
                  {uploading ? '⏳' : '📷'}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <button onClick={onClose} style={styles.cancelButton}>
            Annuler
          </button>
          <button onClick={handleSubmit} style={styles.saveButton}>
            ✓ Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
}